
import Vue from 'vue'
import Vuex from 'vuex'

import LoginApi from '@/plugins/LoginApi'

Vue.use(Vuex)

export default new Vuex.Store({
  state: () => ({
    authUser: null
  }),

  getters: {
    user (state, getters) {
      return state.authUser
    },

    isLoggedIn (state, getters) {
      return state.authUser !== null
    }
  },

  mutations: {
    setUser (state, user) {
      state.authUser = user
    }
  },

  actions: {
    loginWithService ({ commit }, { service, data }) {
      return LoginApi.socialLogin(service, data)
        .then((user) => {
          commit('setUser', user)
          return user
        })
        .catch((error) => {
          console.error(error)
          throw new Error('Bad credentials')
        })
    },

    login ({ commit }, data) {
      return LoginApi.login(data.email, data.password)
        .then((user) => {
          commit('setUser', user)
          return user
        })
        .catch((error) => {
          console.error(error)
          throw new Error('Bad credentials')
        })
    },

    refresh ({ commit }) {
      return LoginApi.me()
        .then((user) => {
          commit('setUser', user)
          return user
        })
        .catch((error) => {
          console.error(error)
          throw new Error('Bad credentials')
        })
    },

    logout ({ commit }) {
      return LoginApi.logout()
        .then((res) => {
          return res
        })
        .then((unauthUser) => {
          commit('setUser', null)
          return unauthUser
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js